import { AuthLayout } from "@/components/layouts/AuthLayout";
import { Link } from "@/components/ui/shadcn/link";
import { Button } from "@/components/ui/shadcn/button";
import { Heading, Text } from "@/components/ui/Typography";
import { ShieldCheck } from "lucide-react";
import { animDelay } from "@/lib/utils";

function ResetPasswordSuccessPage() {
  return (
    <AuthLayout>
      <div className="relative flex w-full max-w-md flex-col items-center text-center">
        <div className="anim-scale-in flex size-20 items-center justify-center rounded-xl bg-success/10">
          <ShieldCheck size={40} className="text-success" />
        </div>

        <div className="anim-slide-up" style={animDelay(200)}>
          <Heading
            variant="h1"
            weight="medium"
            className="mt-6 text-3xl sm:text-3xl"
          >
            Password reset successful
          </Heading>
        </div>

        <div className="anim-fade-in" style={animDelay(300)}>
          <Text variant="text3" className="mt-2 text-muted-foreground">
            Your password has been updated. Sign in with your new credentials.
          </Text>
        </div>

        <div className="anim-slide-up mt-8 w-full" style={animDelay(400)}>
          <Link to="/signin">
            <Button className="w-full">Sign in</Button>
          </Link>
        </div>
      </div>
    </AuthLayout>
  );
}

export default ResetPasswordSuccessPage;
